import React, { useEffect, useState } from "react";
import commonStyles from "../../../Components/Shared/commonStyles.module.css";
import styles from "./Popups.module.css";
import {
  FaMapMarked,
  FaCalendarAlt,
  FaClock,
  FaSearchLocation,
  FaInfoCircle,
} from "react-icons/fa";

import usePopupStore from "../../../Stores/usePopupStore";
import Spinner from "../../../Components/Shared/Spinner/Spinner";
import CallToAction from "../../../Components/Shared/CallToAction/CallToAction";

function Popups() {
  const { getPopups, popups, loading } = usePopupStore();

  const [flippedCards, setFlippedCards] = useState(() => new Set());

  useEffect(() => {
    const fetchPopups = async () => {
      await getPopups();
    };
    if (popups.length === 0) {
      fetchPopups();
    }
  }, [popups.length]);

  const toggleCard = (index) => {
    setFlippedCards((prev) => {
      const next = new Set(prev);
      if (next.has(index)) {
        next.delete(index);
      } else {
        next.add(index);
      }
      return next;
    });
  };

  const formatEventDate = (value) => {
    const parsed = new Date(value);

    if (Number.isNaN(parsed.getTime())) {
      return value;
    }

    return parsed.toLocaleDateString(undefined, {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  const hasDescription = (event) => Boolean(event.Description?.trim());

  return (
    <div className={commonStyles.section}>
      <div className={commonStyles.container}>
        <div className={commonStyles.sectionHeaderContainer}>
          <h2 className={commonStyles.sectionHeader}>
            Visit our Pop-Up Events in Jersey
          </h2>
          <p className={commonStyles.paragraph}>
            Discover our gifts and hampers in person and get inspired for your
            next special occasion. Receive advice while ordering to create
            hampers that are personal and your family will cherish.{" "}
          </p>
          <FaMapMarked className={styles.Map} />
        </div>
        {loading && <Spinner />}
        <div className={`${commonStyles.card} ${styles.EventCardContainer}`}>
          {popups && popups.length === 0 && (
            <p className={styles.noEvents}>
              No upcoming events at the moment. Please check back later for
              updates.
            </p>
          )}
          <div className={`${commonStyles.cards4} ${styles.cards4}`}>
            {popups &&
              popups.map((event, index) => (
                <div key={index} className={styles.FlipCard}>
                  <div
                    className={`${styles.FlipCardInner} ${flippedCards.has(index) ? styles.isFlipped : ""}`}
                  >
                    <div
                      className={`${styles.FlipFace} ${styles.FlipFront} ${styles.EventCard} ${commonStyles.card}`}
                    >
                      {event.Cancelled === true && (
                        <div className={styles.Cancelled}>CANCELLED</div>
                      )}
                      <div className={styles.TitleContainer}>
                        {hasDescription(event) ? (
                          <button
                            type="button"
                            className={`${commonStyles.btn} ${commonStyles.btnSecondary} ${styles.FlipToggle}`}
                            onClick={() => toggleCard(index)}
                            aria-label={`Show details for ${event.Title}`}
                          >
                            <FaInfoCircle className={`${styles.Info}`} />
                          </button>
                  
                        ) : (
                          <span className={styles.FlipToggleSpacer} aria-hidden="true" />
                        )}
                      
                        <h3 className={styles.Title}>{event.Title}</h3>
                      </div>

                      <div className={styles.EventCardItem}>
                        <FaCalendarAlt
                          className={`${styles.Calendar} ${styles.Icon}`}
                        />
                        {formatEventDate(event.Date)}
                      </div>

                      <div
                        className={`${styles.EventCardItem} ${styles.LocationItem}`}
                      >
                        <FaSearchLocation
                          className={`${styles.Location} ${styles.Icon}`}
                        />
                        <span>{event.Location}</span>
                      </div>

                      <div className={styles.EventCardItem}>
                        <FaClock className={`${styles.Clock} ${styles.Icon}`} />
                        {event.Time}
                      </div>

                      <div className={styles.LinksContainer}>
                        {(event.Links || []).map((link, linkIndex) => (
                          <a
                            key={`link-${index}-${linkIndex}`}
                            href={link.Link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`${commonStyles.btn} ${commonStyles.btnSecondary}`}
                          >
                            {link.LinkText}
                          </a>
                        ))}
                        {Array.from({
                          length: Math.max(0, 2 - (event.Links || []).length),
                        }).map((_, emptyIndex) => (
                          <div
                            key={`empty-${index}-${emptyIndex}`}
                            className={styles.LinkPlaceholder}
                            aria-hidden="true"
                          />
                        ))}
                      </div>
                    </div>

                    <div
                      className={`${styles.FlipFace} ${styles.FlipBack} ${commonStyles.card}`}
                    >
                      <h3 className={styles.Title}>{event.Title}</h3>
                      <p className={styles.Description}>
                        {event.Description || "More details coming soon."}
                      </p>
                      <button
                        type="button"
                        className={`${commonStyles.btn} ${commonStyles.btnSecondary} ${styles.BackToEvent}`}
                        onClick={() => toggleCard(index)}
                        aria-label={`Back to front of ${event.Title}`}
                      >
                        Back to event
                      </button>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
      <CallToAction />
    </div>
  );
}

export default Popups;
